import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-new-footer',
  styleUrls: ['./new-footer.component.scss'],
  templateUrl: './new-footer.component.html'
})
export class NewFooterComponent {
  assetsUrl = environment.assetsUrl;
  @Input() footerLite: any;
  @Input() footerError: any;
  @Input() isCDTConfig: any;
  @Input() isBiometrics: any;
}
